module.exports = __webpack_public_path__ + "static/media/ice-rink.6c4551fb.mov";